<template>
    <div class="col-12 col-lg-4 dashboard__box-col">
        <div :class="['box ', color]">
            <h2 class="h h--2">Aktualności</h2>
            <p>To miejsce, w którym znajdziesz wszystkie najnowsze i najprzydatniejsze informacje - bądź na bieżąco!</p>
            <router-link :to="{name: 'NewsList'}" class="button button__bottom">Zobacz listę &raquo;</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewsWidget',
        props: {
            color: {
                default: 'box--blue'
            },
        },
        data () {
            return {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/news/NewsWidget.vue